/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface GetByBookingidGeneratePdf$Params {
  BookingId: number;
  SiteName?: string;
}

export function getByBookingidGeneratePdf(
  http: HttpClient,
  rootUrl: string,
  params: GetByBookingidGeneratePdf$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, getByBookingidGeneratePdf.PATH, 'get');
  if (params) {
    rb.path('BookingId', params.BookingId, {});
    rb.query('SiteName', params.SiteName, {});
  }

  return http.request(rb.build({ responseType: 'blob', accept: 'application/pdf', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    }),
  );
}

getByBookingidGeneratePdf.PATH = '/Bookings/{BookingId}/generate-pdf';
